"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSyncActionCreatorKey = createSyncActionCreatorKey;
exports.createSyncActionCreatorDataValue = createSyncActionCreatorDataValue;
exports.createSyncActionCreator = createSyncActionCreator;
const lib_1 = require("../../lib/string/lib.js");
const lib_2 = require("../actionTypes/lib.js");
function createSyncActionCreatorKey(options) {
    const { syncVerb, name } = options;
    const syncVerbLowercased = syncVerb.toLowerCase();
    const nameCapitalized = (0, lib_1.capitalize)(name);
    return `${syncVerbLowercased}${nameCapitalized}`;
}
function createSyncActionCreatorDataValue(options) {
    const actionTypeValue = (0, lib_2.createSyncActionTypeValue)(options);
    return function (data) {
        return {
            data,
            type: actionTypeValue
        };
    };
}
function createSyncActionCreatorTypeValue(options) {
    const actionTypeValue = (0, lib_2.createSyncActionTypeValue)(options);
    return function () {
        return {
            type: actionTypeValue
        };
    };
}
function createSyncActionCreator(options) {
    return options.hasRequest ?
        createSyncActionCreatorDataValue(options) :
        createSyncActionCreatorTypeValue(options);
}
//# sourceMappingURL=lib.js.map